import React from 'react';
import { useFeelingAloneAi } from './FeelingAloneAiContext';
import { useTranslation } from '../../i18n';
import '../../styles/feeling-alone-ai.css';

interface FeelingAloneAddAiProps {
  /** sidebar = host casting standings; compact = host-as-player under expand/collapse */
  variant?: 'sidebar' | 'compact';
}

/**
 * Mid-game solo nudge. Visibility comes from FeelingAloneAiProvider (host-only).
 */
export const FeelingAloneAddAi: React.FC<FeelingAloneAddAiProps> = ({ variant = 'sidebar' }) => {
  const feelingAlone = useFeelingAloneAi();
  const { t } = useTranslation();

  if (!feelingAlone?.shouldShow) {
    return null;
  }

  return (
    <div
      className={`feeling-alone-ai feeling-alone-ai--${variant}`}
      data-testid="feeling-alone-ai"
    >
      <button
        type="button"
        className="feeling-alone-ai__close"
        onClick={feelingAlone.dismiss}
        aria-label={t('lobby.ai.feelingAloneDismissAria')}
        title={t('lobby.ai.feelingAloneDismissAria')}
      >
        ×
      </button>
      <p className="feeling-alone-ai__label">{t('lobby.ai.feelingAlone')}</p>
      <button
        type="button"
        className="feeling-alone-ai__btn"
        onClick={feelingAlone.addAiPlayer}
        disabled={feelingAlone.adding}
      >
        {feelingAlone.adding ? t('lobby.ai.addingPlayer') : t('lobby.ai.addPlayer')}
      </button>
    </div>
  );
};
